var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C9.44772 2 9 2.44772 9 3C9 3.55228 9.44772 4 10 4H14C14.5523 4 15 3.55228 15 3C15 2.44772 14.5523 2 14 2H10ZM2 6.5C2 5.94772 2.44772 5.5 3 5.5H21C21.5523 5.5 22 5.94772 22 6.5C22 7.05228 21.5523 7.5 21 7.5H19.9669L19.1965 18.285C19.047 20.3783 17.3052 22 15.2067 22H8.78678C6.69187 22 4.95183 20.3837 4.79763 18.2945L4.00276 7.52526C4.00214 7.51683 4.00162 7.5084 4.00121 7.5H3C2.44772 7.5 2 7.05228 2 6.5ZM6.00633 7.5H17.9618L17.2016 18.1425C17.1268 19.1891 16.256 20 15.2067 20H8.78678C7.73932 20 6.86931 19.1919 6.7922 18.1473L6.00633 7.5ZM10 10C10.5523 10 11 10.4477 11 11V16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16V11C9 10.4477 9.44772 10 10 10ZM15 11C15 10.4477 14.5523 10 14 10C13.4477 10 13 10.4477 13 11V16C13 16.5523 13.4477 17 14 17C14.5523 17 15 16.5523 15 16V11Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.ca73eb1ecd72578b841cd425049aacc7.svg";
export { ForwardRef as ReactComponent };